import '../styles/index.css';
import { useEffect, useState } from 'react';

export interface TransitionOverlayProps {
  type: 'fade' | 'flash' | 'battle_like' | string;
  durationMs?: number;
  onComplete?: () => void;
  active?: boolean;
}

export function TransitionOverlay({
  type,
  durationMs = 1000,
  onComplete,
  active = true,
}: TransitionOverlayProps) {
  const [visible, setVisible] = useState(active);

  useEffect(() => {
    if (!active) {
      setVisible(false);
      return;
    }

    setVisible(true);

    const timer = setTimeout(() => {
      setVisible(false);
      onComplete?.();
    }, durationMs);

    return () => clearTimeout(timer);
  }, [active, durationMs, onComplete]);

  if (!visible) return null;

  const style = {
    '--pawa-duration': `${durationMs}ms`,
  } as React.CSSProperties;

  const typeClass = ['fade', 'flash', 'battle_like'].includes(type)
    ? `pawa-transition-${type}`
    : 'pawa-transition-fade';

  return (
    <div
      className={`pawa-transition-overlay ${typeClass}`}
      style={style}
      role="presentation"
      aria-hidden="true"
      data-transition-type={type}
    />
  );
}
